/**
 * El aviso de una etiqueta que cambió DESDE EL CELULAR (19-oct-2026; broadcast `wa_etiqueta_del_celular`).
 *
 * El founder lo pidió después del de las respuestas rápidas: «¿se puede ver una alerta del cambio, como cuando se
 * confirma una venta?». La bandeja ya mostraba la etiqueta en vivo, pero sin avisar. El servidor avisa SÓLO lo que
 * llegó del celular y cambió de verdad (el eco de lo que puso Smarty no cuenta). Puro.
 */
export interface EtiquetaDelCelular {
  conversation_id: string;
  etiqueta: string;
  puesta: boolean;
}

/** Lo que trae el broadcast, leído sin confiar. */
export function laEtiquetaDelAviso(p: unknown): EtiquetaDelCelular | null {
  const o = (p ?? {}) as Record<string, unknown>;
  if (typeof o.conversation_id !== 'string' || typeof o.etiqueta !== 'string' || !o.etiqueta) return null;
  return { conversation_id: o.conversation_id, etiqueta: o.etiqueta, puesta: o.puesta === true };
}

/** El texto de una tanda (varias seguidas son UN aviso) y el chat que abre al tocarlo: el último. */
export function elTextoDelAviso(tanda: EtiquetaDelCelular[]): { conversationId: string; texto: string } | null {
  if (tanda.length === 0) return null;
  const ultima = tanda[tanda.length - 1];
  const chats = new Set(tanda.map((e) => e.conversation_id));
  const una = (e: EtiquetaDelCelular) => `«${e.etiqueta}» ${e.puesta ? 'puesta' : 'quitada'}`;
  let detalle: string;
  if (chats.size > 1) detalle = `${tanda.length} etiquetas en ${chats.size} chats`;
  else if (tanda.length <= 3) detalle = tanda.map(una).join(' · ');
  else detalle = `${tanda.length} etiquetas cambiaron`;
  return { conversationId: ultima.conversation_id, texto: `🏷️ Desde el celular: ${detalle}` };
}
